import { AppContent } from '@app/components/app-content';
import { AppShell } from '@app/components/app-shell';
import { AppSidebar } from '@app/components/app-sidebar';
import { AppSidebarHeader } from '@app/components/app-sidebar-header';
import SscaCopyrights from '@app/components/ssca-copyrights';
import AppWrapper from '@app/layouts/app-wrapper';
import { type PropsWithChildren } from 'react';

export default function AppSidebarLayout({ children }: PropsWithChildren) {
    return (
        <AppWrapper>
            <AppShell variant="sidebar">
                <AppSidebar />
                <div className="flex w-full flex-col">
                    <AppContent variant="sidebar">
                        <AppSidebarHeader />
                        {children}
                    </AppContent>
                    <div className="w-full py-2 text-center">
                        <SscaCopyrights />
                    </div>
                </div>
            </AppShell>
        </AppWrapper>
    );
}
